import { IconColor } from './contract/icon-color.contract';
import { IconSize } from './contract/icon-size.contract';
import { IconWeight } from './contract/icon-weight.contract';

export const ICON_SIZES: Record<IconSize, string> = {
  small: 'icon-size--small',
  medium: 'icon-size--medium',
  large: 'icon-size--large',
  xLarge: 'icon-size--x-large',
  xxLarge: 'icon-size--xx-large'
};

export const ICON_COLORS: Record<IconColor, string> = {
  primary: 'icon-color--primary',
  'text-primary': 'icon-color--text-primary',
  'text-secondary': 'icon-color--text-secondary',
  'button-text': 'icon-color--button-text',
};

export const ICON_COLORS_HOVER: Record<IconColor, string> = {
  primary: 'icon-hover icon-color-hover--primary',
  'text-primary': 'icon-hover icon-color-hover--text-primary',
  'text-secondary': 'icon-hover icon-color-hover--text-secondary',
  'button-text': 'icon-hover icon-color-hover--button-text',
};

export const ICON_WEIGHTS: Record<IconWeight, string> = {
  light: 'icon-weight--light',
  normal: 'icon-weight--normal',
  medium: 'icon-weight--medium',
  semibold: 'icon-weight--semibold',
  bold: 'icon-weight--bold',
};
